var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 193,
    viewBox: "0 0 327 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.838 88.2318C126.351 87.4657 127.483 87.4657 127.996 88.2318L152.356 124.655C152.928 125.509 152.311 126.653 151.277 126.653H102.557C101.524 126.653 100.906 125.509 101.478 124.655L125.838 88.2318Z",
    fill: "#E4EFF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.605 61.2401C179.117 60.4682 180.257 60.4681 180.769 61.2401L222.804 124.659C223.371 125.514 222.753 126.652 221.723 126.652H137.652C136.621 126.652 136.003 125.514 136.57 124.659L178.605 61.2401Z",
    fill: "#E4EFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.371 80.1873C151.539 80.1873 156.54 75.2205 156.54 69.0936C156.54 62.9668 151.539 58 145.371 58C139.202 58 134.202 62.9668 134.202 69.0936C134.202 75.2205 139.202 80.1873 145.371 80.1873Z",
    fill: "#E4EFF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 323,
    height: 189,
    rx: 6,
    stroke: "#E4EFF8",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholder_img.2bdbe93222b0a60c21dc04f0146db29c.svg";
export { ForwardRef as ReactComponent };